// extracted by mini-css-extract-plugin
export default {"container":"BgYoJ","title":"lzqe6"};